<template>
  <div class="sys-meta">
    <UserAvatar class="meta-avatar" :user-avatar="meta.avatar" />
    <div class="meta-body text-black line-clamp-text">
      {{meta.corpName}}-{{meta.name}}<span class="text-grey" style="padding: 0 4px"
        >{{act}}</span
      >
    </div>
  </div>
</template>
<script>
// 加好友meta
import UserAvatar from '@/components/business/avatar/UserAvatar.vue'
import { INVITE_STATUS } from '@/utils/constant'

export default {
  name: 'FriendMeta',
  props: {
    meta: {
      type: Object,
      required: true
    }
  },
  components: {
    UserAvatar
  },
  computed: {
    act() {
      switch (this.meta.actType) {
        case INVITE_STATUS.ACCEPT:
          return this.$t('home.AgreedRequest')
        case INVITE_STATUS.REJECT:
          return this.$t('home.DeclinedRequest')
        default: // 此处返回这段话不矛盾，因为其他状态文本是给接收方看的
          return this.$t('home.ApplyFriend')
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import url(~@/styles/font.less);
@import url(./meta.less);
.sys-meta {
  .meta();
  .meta-body {
    line-height: 48px;
  }
}
</style>
